<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Addresse bearbeiten') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.put(route('admin.addresses.update', address))">
                <form-fields :form="form" :customer="customer" :address="address" :countries="countries" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'customer',
            'address',
            'countries',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    country_id: this.address.country_id,
                    company: this.address.company,
                    salutation: this.address.salutation,
                    title: this.address.title,
                    first_name: this.address.first_name,
                    last_name: this.address.last_name,
                    city: this.address.city,
                    street: this.address.street,
                    house_number: this.address.house_number,
                    zip_code: this.address.zip_code,
                    county: this.address.county,
                    phone: this.address.phone,
                    notes: this.address.notes,
                    default_billing_address: this.address.is_default_billing_address,
                    default_delivery_address: this.address.is_default_delivery_address,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>